<template>
  <v-container fluid>
    <PageHeading
      text="Роли"
      mode="grid"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    >
      <template v-slot:[`toolbar.prepend`]>
        <v-btn
          link
          small
          outlined
          color="primary"
          class="mx-2 mt-2"
          :to="{
            name: 'page-role-new'
          }"
        >
          <v-icon
            class="mr-2"
            small
          >
            mdi-plus
          </v-icon>
          Создать роль
        </v-btn>
      </template>
    </PageHeading>
    <v-row>
      <v-col>
        <GridRoles ref="grid"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GridRoles from './grid'
import PageHeading from '@/components/page-heading'
import gridPageInterface from '@/interfaces/grid-page-interface-mixin'

export default {
  components: {
    PageHeading,
    GridRoles
  },
  metaInfo () {
    return {
      title: 'Роли'
    }
  },
  mixins: [gridPageInterface]
}
</script>
